/*
Notes:项目合同
Date:2019/10/25 xieGy
*/

import axios from 'axios';
import ajax from './ajax'; // 引用二次封装ajax.js

export default {
  // 获取项目合同列表
  getProjectContractList (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/blReadContractList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
   // 获取主合同列表
  getMainContractList (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/blMainContractList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
  signContract (params) {
	    return ajax.postForm('/mobile/item/shortcutSignature/blPdfSignatureCustomer.ht', params);
  },
  signContractForMain (params) {
    return ajax.postForm('/mobile/item/pdfSignatureController/customerSignMainContract.ht', params);
  },
  checkNum (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/waiSignInfo.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/projectContract.js